import React from 'react';

// Services && Constants
import { dateWithTimezone } from 'src/services/date';

// Components
import ArrivalDelay from 'src/views/practitioner/components/ArrivalDelay';

// Styles & Images
import { Time, TimeLine } from './tableStyles';
import CamIcon from '../../../../../assets/images/cam.svg';


// Util functions
import { isVideoConsultation } from '../../../../../services/appointment';

export default ({ appointment }) => {


  return (
    <React.Fragment>
      <TimeLine className="time-line" />
      <Time>
        <div>
          <div style={{ display: 'flex' }}>
            {isVideoConsultation(appointment) && <img src={CamIcon} alt="cam-icon" style={{ marginRight: '8px' }} />}
            <span>{dateWithTimezone(appointment && appointment.dateTime)}</span>
          </div>
          <ArrivalDelay appointment={appointment} />
        </div>
      </Time>
    </React.Fragment>
  );
};
